module.exports = __webpack_public_path__ + "img/helpAndSupportRe.8abea02c.svg";